import React, { Component } from 'react'
import Footer from '../Footer';
import Nav from '../Nav';
import GaugeChart from 'react-gauge-chart'

import { p } from './temp';

const axios = require('axios');

const env = 'prod';

export default class Rarity extends Component {


  state = {
    walletName: '',
    omniAddress: '',
    stargazeAdd: '',
    junoPixNots: [],
    huaNots: [],

    rarity: [],
    starNots: [],
    loading: false,
    loadingHua: false,

    starPixs: [],
    loadingStarPixs: false,

    osmoPixs: [],
    loadingOsmoPixs: false,

    junoPixs: [],
    loadingJunoPixs: false,

    junoNots: [],
    loadingJunoNots: false,

    freedomNots: [],
    loadingFreedomNots: false,

    heroNots: [],
    loadingHeroNots: false,

  }

  async componentDidMount() {

    // await this.connectKeplr();

    window.addEventListener("keplr_keystorechange", (async () => {
      await this.connectKeplr();
    }));

    let temp = []

    for (const key in p) {
      temp.push({
        id: key,
        value: p[key]
      })
    }

    this.setState({
      rarity: temp
    })

  }

  async connectKeplr() {
    if (window.keplr) {
      try {

        let r = await window.keplr.enable('omniflixhub-1');

        await this.getWalletDetails();

        await this.getWalletDetailsStargaze();

      } catch (error) {
        console.log(error);
      }
    }
  }

  async getWalletDetails() {
    if (window.keplr) {
      try {

        let r = await window.keplr.enable('omniflixhub-1');

        const { name, bech32Address } = await window.keplr.getKey('omniflixhub-1')

        this.setState({
          walletName: name,
          omniAddress: bech32Address
        });

        setTimeout(async () => {
          // this.getOmniNfts()
        }, 200)

      } catch (error) {
        console.log(error);
      }
    }
  }

  async getWalletDetailsStargaze() {
    if (window.keplr) {
      try {

        let r = await window.keplr.enable('stargaze-1');

        const { name, bech32Address } = await window.keplr.getKey('stargaze-1')

        this.setState({
          walletName: name,
          stargazeAdd: bech32Address
        });

        // this.setState({
        //   stargazeAdd : 'stars1qxh8dfj72vymqnqamatdn5e8zmun5ggxpv6yqd',
        //   omniAddress : 'omniflix1qxh8dfj72vymqnqamatdn5e8zmun5ggxgwuquz'
        // })


        setTimeout(async () => {

          // this.getOmniNfts()
          this.getJunoNots();
          this.getStarNots();
          this.getHuaNots();
          this.getStarPixs();
          this.getFreedomNots();
          this.getHeroNots();
          this.getJunoPixs();

        }, 200)

      } catch (error) {
        console.log(error);
      }
    }
  }

  async getOmniNfts() {
    try {

      const { omniAddress } = this.state

      // let host = 'https://rest.omniflix.network/';

      let heroNotsDenom = 'onftdenom46f25204760c474a84ecc65071fdb7e3';
      let junoNotsDenom = 'onftdenom088c43277fb047a48bf0d38f51806b8b';
      let freedomNotsDenom = 'onftdenom898fcb492ae3445395f919ffefb38724';
      let huaNotsDenom = 'onftdenomb9774877717647e9be2b7925b5ff88ff';
      let junoPixDenom = 'onftdenomfeca45fb70b54cd58a8901e866a86c1e';

      // let reqUrl = `${host}omniflix/onft/v1beta1/onfts/${junonotsDenom}/${omniAddress}`

      // let collectionURL = `${host}omniflix/onft/v1beta1/collections/${junonotsDenom}`


      let reqURL = `https://data-api.omniflix.studio/nfts?owner=${omniAddress}`

      // let reqURL = `https://data-api.omniflix.studio/nfts?owner=omniflix1kt3l4uvkpmr2qa09xyktsstkgaqa8z4pjvxtyd`

      const { data } = await axios.get(reqURL);

      if (data.result) {

        let nfts = data.result.list;

        if (nfts) {

          let heroNots = nfts.filter(e => {
            return e.denom_id.id === heroNotsDenom
          });

          let junoNfts = nfts.filter(e => {
            return e.denom_id.id === junoNotsDenom
          });

          let freedomNots = nfts.filter(e => {
            return e.denom_id.id === freedomNotsDenom
          });

          let huaNots = nfts.filter(e => {
            return e.denom_id.id === huaNotsDenom
          });

          let junoPix = nfts.filter(e => {
            return e.denom_id.id === junoPixDenom
          });


          let huaNotsList = []

          huaNots.map(e => {
            huaNotsList.push({
              ...e,
              rarityValue: this.getRarityValue(e.name)
            })
          });

          huaNotsList.sort(function (a, b) { return a.rarityValue - b.rarityValue });

          this.setState({
            junoPixNots: junoPix,
            heroNots: heroNots,
            freedomNots: freedomNots,
            huaNots: huaNotsList,
            junoNots: junoNfts
          });

        }

      } else {
        console.log('No NFT FOUND');
      }



      // console.log(data.collection.onfts.length);


    } catch (error) {
      console.log(error);
    }
  }

  async getStarNots() {

    this.setState({
      loading: true
    })

    try {

      const { stargazeAdd, omniAddress } = this.state;

      let url = `https://nots-core.herokuapp.com/nft/starNots?account=${stargazeAdd}&omni=${omniAddress}`

      // let url = `https://nots-core.herokuapp.com/nft/starNots?account=stars14pjsxrl852gxj4p8hu4euc9wqvhgjpr4umyqwm&omni=omniflix14pjsxrl852gxj4p8hu4euc9wqvhgjpr44ezyj5`

      const { data } = await axios.get(url);

      if (data.data) {
        this.setState({
          starNots: data.data.sort((a, b) => { return parseInt(a.Rank) - parseInt(b.Rank) })
        })
      } else {
        this.setState({
          starNots: []
        })
      }

      this.setState({
        loading: false
      })

    } catch (error) {
      console.log('error', error);
      this.setState({
        loading: false
      })
    }
  }

  async getHuaNots() {



    this.setState({
      loadingHua: true
    })

    try {

      const { stargazeAdd, omniAddress } = this.state;

      // let url = `https://nots-core.herokuapp.com/nft/HuaNots?omni=omniflix14pjsxrl852gxj4p8hu4euc9wqvhgjpr44ezyj5`

      // let om = 'omniflix14pjsxrl852gxj4p8hu4euc9wqvhgjpr44ezyj5'

      let url = `https://nots-core.herokuapp.com/nft/HuaNots?omni=${omniAddress}&account=${stargazeAdd}`
      

      const { data } = await axios.get(url);

      console.log(data);

      if (data.data) {
        this.setState({
          huaNots: data.data.sort((a, b) => { return parseInt(a.Rank) - parseInt(b.Rank) })
        })
      } else {
        this.setState({
          huaNots: []
        })
      }

      this.setState({
        loadingHua: false
      })

    } catch (error) {
      console.log('error', error);

      this.setState({
        loadingHua: false
      })
    }


  }

  async getStarPixs() {
    this.setState({
      loadingStarPixs: true
    })

    try {
      const { stargazeAdd, omniAddress } = this.state;
      // let url = `https://nots-core.herokuapp.com/nft/HuaNots?omni=omniflix14pjsxrl852gxj4p8hu4euc9wqvhgjpr44ezyj5`
      let url = `https://nots-core.herokuapp.com/nft/StarPix?omni=${omniAddress}`

      if (env === 'dev') {
        url = `https://nots-core.herokuapp.com/nft/StarPix?omni=omniflix154ynm3sdmprq5ete8s49l84eg66er9z5wcq6ns`
      }

      const { data } = await axios.get(url);
      if (data.data) {
        this.setState({
          starPixs: data.data
        })
      } else {
        this.setState({
          starPixs: []
        })
      }
      this.setState({
        loadingStarPixs: false
      })
    } catch (error) {
      console.log('error', error);

      this.setState({
        loadingStarPixs: false
      })
    }
  }

  async getJunoPixs() {
    this.setState({
      loadingJunoPixs: true
    })

    try {
      const { stargazeAdd, omniAddress } = this.state;
      // let url = `https://nots-core.herokuapp.com/nft/HuaNots?omni=omniflix14pjsxrl852gxj4p8hu4euc9wqvhgjpr44ezyj5`
      let url = `https://nots-core.herokuapp.com/nft/JunoPix?omni=${omniAddress}`

      if (env === 'dev') {
        url = `https://nots-core.herokuapp.com/nft/JunoPix?omni=omniflix1973qhhswmsf0y99h88t40v7ecgzqhs6rzt6hwn`
      }

      const { data } = await axios.get(url);

      console.log(data.data);
      if (data.data) {
        this.setState({
          junoPixs: data.data
        })
      } else {
        this.setState({
          junoPixs: []
        })
      }
      this.setState({
        loadingJunoPixs: false
      })
    } catch (error) {
      console.log('error', error);

      this.setState({
        loadingJunoPixs: false
      })
    }
  }


  async getJunoNots() {
    this.setState({
      loadingJunoNots: true
    })

    try {
      const { stargazeAdd, omniAddress } = this.state;
      // let url = `https://nots-core.herokuapp.com/nft/HuaNots?omni=omniflix14pjsxrl852gxj4p8hu4euc9wqvhgjpr44ezyj5`
      let url = `https://nots-core.herokuapp.com/nft/JunoNots?account=${stargazeAdd}&omni=${omniAddress}`

      if (env === 'dev') {
        url = `https://nots-core.herokuapp.com/nft/JunoNots?account=stars154ynm3sdmprq5ete8s49l84eg66er9z586x70l&omni=omniflix16mq9lwkz5mu7n45z5ecdtawp37lhcf6c04jwc9`
      }

      const { data } = await axios.get(url);
      if (data.data) {
        this.setState({
          junoNots: data.data
        })
      } else {
        this.setState({
          junoNots: []
        })
      }
      this.setState({
        loadingJunoNots: false
      })
    } catch (error) {
      console.log('error', error);

      this.setState({
        loadingJunoNots: false
      })
    }
  }

  async getFreedomNots() {
    this.setState({
      loadingFreedomNots: true
    })

    try {
      const { stargazeAdd, omniAddress } = this.state;
      let url = `https://nots-core.herokuapp.com/nft/FreedomNots?omni=${omniAddress}`

      if (env === 'dev') {
        url = `https://nots-core.herokuapp.com/nft/FreedomNots?omni=omniflix1e00s43ktrvh55uwu8r8z7puvyzv429mlhnpn2h`
      }

      const { data } = await axios.get(url);
      if (data.data) {
        this.setState({
          freedomNots: data.data
        })
      } else {
        this.setState({
          freedomNots: []
        })
      }
      this.setState({
        loadingFreedomNots: false
      })
    } catch (error) {
      console.log('error', error);

      this.setState({
        loadingFreedomNots: false
      })
    }
  }

  async getHeroNots() {
    this.setState({
      loadingHeroNots: true
    })

    try {
      const { stargazeAdd, omniAddress } = this.state;

      let url = `https://nots-core.herokuapp.com/nft/3DNots?omni=${omniAddress}`
      if (env === 'dev') {
        url = `https://nots-core.herokuapp.com/nft/3DNots?omni=omniflix1w6dpa2l2fc3v2rc9dpuhqg4lt6ykvlqga387al`
      }
      const { data } = await axios.get(url);
      if (data.data) {
        this.setState({
          heroNots: data.data
        })
      } else {
        this.setState({
          heroNots: []
        })
      }
      this.setState({
        loadingHeroNots: false
      })
    } catch (error) {
      console.log('error', error);

      this.setState({
        loadingHeroNots: false
      })
    }
  }

  getFirstWord(str) {
    return str.split(' ').shift().replace(/[0-9]/g, '').replace(' ', '').toLowerCase();
  }

  getName(str) {
    return str.replace(' ', '_');
  }

  getRarityValue(name) {
    const { rarity } = this.state;
    let index = parseInt(name.replace("HuaNots #", "")) - 1;
    // console.log(name,rarity[index].value);
    return rarity[index].value;
  }

  getValue(name, att) {
    let f = att.find(f => { return f.trait_type === name })

    if (f) {
      return f.value
    } else {
      return ''
    }
  }

  getSeriesBadge(type) {
    let rarity = <p></p>

    console.log(type);

    if(!type){
      return <></>
    }

    if (type.includes('Celestial')) {
      rarity = <p className='bg-danger badge mt-2'>Celestial</p>
    }

    if (type.includes('Cosmic')) {
      rarity = <p className='bg-orange badge mt-2'>Cosmic</p>
    }

    if (type.includes('Meteoric')) {
      rarity = <p className='bg-warning badge mt-2'>Meteoric</p>
    }

    if (type.includes('Stellar')) {
      rarity = <p className='bg-success badge mt-2'>Stellar</p>
    }

    if (type.includes('Orbital')) {
      rarity = <p className='bg-muted badge mt-2'>Orbital</p>
    }

    return rarity;
  }


  render() {

    const { walletName, omniAddress,
      huaNots, junoPixNots,
       junoNots, starNots, loading, loadingHua,
      starPixs, loadingStarPixs,loadingJunoNots ,
    freedomNots,loadingFreedomNots,heroNots,loadingHeroNots,
    junoPixs,loadingJunoPixs} = this.state


    return (
      <>
        <Nav />

        <section className="home-3 section cta-2" style={{
          marginTop: -50
        }}>
          <div className="container">
            <div className="cta-box">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="cta-content">
                    <h1 className="text-white">Check Your Nots
                      <span><b> Rarity</b></span> Here </h1>
                    <br />
                    <button className='btn btn-primary'
                      onClick={async () => {
                        await this.connectKeplr()
                      }}>{
                        (omniAddress === '') ? 'Connect Your Wallet' : 'Connected'
                      }</button>
                    <br />
                    <br />
                    <p className='text-white'><b>{walletName}</b> : {
                      `${omniAddress.substring(0, 5)}.....${omniAddress.substring(omniAddress.length - 4, omniAddress.length)}`
                    }</p>

                    <p className=''>Please note that this currently only supports <b className='text-danger'>StarNots</b> on the <b className='text-success'>OmniFLix Network and Stargaze Networks</b></p>
                    <hr />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="cta-image">
                    <img src="images/not.png" alt="" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        <div className="container" style={{
          marginTop: -90
        }}>

          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="text-center">
                <h6 className="text-gradiant fw-bold"></h6>
                <br />
                <h1 className="fw-bold">StarNots</h1>
                <h6 className='text-white'>
                  StarNOTs are humanistic space bots in Cosmos that love the arts and creativity. StarNOTs defend and build up the art community on the Stargaze homeworld.
                </h6>
                <p className='bg-orange badge m-1'>Cosmic <b>10%</b></p>
                <p className='bg-warning badge m-1'>Meteoric <b>15%</b></p>
                <p className='bg-success badge m-1'>Stellar <b>30%</b></p>
                <p className='bg-muted badge m-1'>Orbital <b>40%</b></p>

              </div>
            </div>
          </div>
        </div>

        <div className="container mt-5">
          <div className="row justify-content-center">
            {
              starNots.map((e, i) => {

                let rarity = this.getSeriesBadge(this.getValue('Base', e.attributes))

                console.log(e);

                let score = parseInt(e.Score);

                let getPercent = ((score - 2800) * 100) / (6050 - 2800);

                console.log(score, getPercent);

                let attributes = []

                e.attributes.map(att => {
                  attributes.push(
                    <p className='bg-soft-info badge m-1'>{att.value}</p>
                  )
                })

                let image = ''

                if (e.chain === 'omni') {
                  image = `https://nots.mypinata.cloud/ipfs/QmdB13msyZKGVHuEaUqfqSTzn91UWcY8E3e8RxJrUNiYDb/StarNots_${e.edition}.png`;
                } else {
                  image = e.image.replace('ipfs://', 'https://nots.mypinata.cloud/ipfs/')
                }

                return <div className='col-md-6' key={i.toString()}>
                  <div className='flex-row justify-content-between card p-2 mt-3'>
                    <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div>
                    <div className='' style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      <img src={image} className="mt-2" width={200} />
                      {rarity}
                      <GaugeChart id="gauge-chart2"
                        nrOfLevels={20}
                        percent={getPercent / 100}
                        colors={['#EA4228', '#F5CD19', '#5BE12C']}
                        style={{
                          width: 200
                        }}
                      />
                      <span className='info text-center'> Total rarity score %</span>
                    </div>

                    <div className='flex-fill'>
                      {e.chain === 'omni' ?
                        <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img' /> :
                        <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img' />
                      }
                      <h3 className='text-center nft-name'>{e.name}</h3>
                      <div style={{
                        paddingLeft: 10
                      }}>
                        {
                          attributes
                        }
                      </div>
                    </div>

                  </div>
                </div>
              })
            }
            {
              starNots.length === 0 &&
              <p className='card card-header text-center'>{loading ? 'Loading...' : 'No StarNots Found'}</p>
            }
          </div>
        </div>


        <br /> <br />


<div className="container" style={{}}>

  <div className="row justify-content-center">
    <div className="col-lg-12">
      <div className="text-center">
        <h6 className="text-gradiant fw-bold"></h6>
        <br />
        <h1 className="fw-bold">HuaNOTs</h1>

        <h6 className='text-white'>
          HuaNOTs are high utility NFTs that are each backed with 10,000 Huahua and offer staking commission discounts on NOTs.ART validator.
        </h6>

        <p className='bg-danger badge m-1'>Celestial <b>5%</b></p>
        <p className='bg-orange badge m-1'>Cosmic <b>10%</b></p>
        <p className='bg-warning badge m-1'>Meteoric <b>15%</b></p>
        <p className='bg-success badge m-1'>Stellar <b>30%</b></p>
        <p className='bg-muted badge m-1'>Orbital <b>40%</b></p>

      </div>
    </div>
  </div>
</div>

<div className="container mt-5">
  <div className="row justify-content-center">
    {
      huaNots.map((e, i) => {

        
        if(e.chain === 'stargaze'){
          console.log(e);
          let data = e.details;
          let rarity = this.getSeriesBadge(data.attributes.find(att => {return att.trait_type == 'type'}).value);
          let score = e.Score;
          let getPercent = ((score - 3600) * 100) / (7650 - 3600);
          let attributes = []
          data.attributes.map(att =>{
            attributes.push(
              <p className='bg-soft-info badge m-1'>{att.value}</p>
            )
          })
          let image = e.image;
          return (<div className='col-md-6' key={i.toString()}>
          <div className='flex-row justify-content-between card p-2 mt-3'>
          <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div>
            <div className='' style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
                <img src={image} className="mt-2" width={200} />
              {rarity}
              <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                percent={getPercent/100}
                colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                style={{
                  width : 200
                }}
              />
              <span className='info text-center'> Total rarity score %</span>
            </div>

            <div className='flex-fill'>
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
              <h3 className='text-center nft-name'>{e.details.name}</h3>
              <div style={{
                paddingLeft : 10
              }}>
                {
                  attributes
                }
              </div>
            </div>

          </div>
        </div>);
        }else{
          let data = JSON.parse(e.data)

          let rarity = this.getSeriesBadge(data.type)
          
          let score = e.Score;
  
          let getPercent = ((score - 3600) * 100) / (7650 - 3600);
  
          let attributes = []
  
          for (var key of Object.keys(data)) {
            attributes.push(
              <p className='bg-soft-info badge m-1'>{data[key]}</p>
            )
          }
          let image = e.media_uri;
          return <div className='col-md-6' key={i.toString()}>
            <div className='flex-row justify-content-between card p-2 mt-3'>
            <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div>
              <div className='' style={{
                display: 'flex',
                flexDirection: 'column'
              }}>
                  <img src={image} className="mt-2" width={200} />
                {rarity}
                <GaugeChart id="gauge-chart2"
                  nrOfLevels={20}
                  percent={getPercent/100}
                  colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                  style={{
                    width : 200
                  }}
                />
                <span className='info text-center'> Total rarity score %</span>
              </div>
  
              <div className='flex-fill'>
                {e.chain === 'omni' ?
                 <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
                 <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
                }
                <h3 className='text-center nft-name'>{e.name}</h3>
                <div style={{
                  paddingLeft : 10
                }}>
                  {
                    attributes
                  }
                </div>
              </div>
  
            </div>
          </div>
        }
      })
    }
    {
      huaNots.length === 0 &&
      <p className='card card-header text-center'>{loadingHua ? 'Loading...' : 'No HuaNots Found'}</p>
    }
  </div>
</div>
<br /> <br />
<div className="container" style={{}}>

  <div className="row justify-content-center">
    <div className="col-lg-12">
      <div className="text-center">
        <h6 className="text-gradiant fw-bold"></h6>
        <br />
        <h1 className="fw-bold">JunoNots</h1>

        <h6 className='text-white'>
          JunoNOTs are the fusion of high utility NFTs with staking in Cosmos. JunoNOTs are the IBC Juno defenders of Cosmos.
        </h6>

        <p className='bg-danger badge m-1'>Celestial <b>5%</b></p>
        <p className='bg-orange badge m-1'>Cosmic <b>10%</b></p>
        <p className='bg-warning badge m-1'>Meteoric <b>15%</b></p>
        <p className='bg-success badge m-1'>Stellar <b>30%</b></p>
        <p className='bg-muted badge m-1'>Orbital <b>40%</b></p>

      </div>
    </div>
  </div>
</div>

<div className="container mt-5">
  <div className="row justify-content-center">
    {
      junoNots.map((e, i) => {

        let rarity = this.getSeriesBadge(e.Pose)
        
        let score = parseInt(e['Total Point']);

        let getPercent = ((score - 2610) * 100) / (8135 - 2610);

        let attributes = []

        let image = e.image;

        return <div className='col-md-3' key={i.toString()}>
          <div className='flex-row justify-content-between card p-2 mt-3'>
          <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div>
            <div className='' style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent : 'center',
              alignItems : 'center',
              flex : 1,
            }}>
                <img src={image} className="mt-2" height={200} />
                <h3 className='text-center nft-name'>JunoNot #{e['JunoNot Number']}</h3>
              {rarity}
              <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                animate={false}
                percent={getPercent/100}
                colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                style={{
                  width : 200
                }}
              />
              <span className='info text-center'> Total rarity score %</span>
          
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
            </div>

            {/* <div className='flex-fill'>
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
              <h3 className='text-center nft-name'>{e.name}</h3>
              <div style={{
                paddingLeft : 10
              }}>
                {
                  attributes
                }
              </div>
            </div> */}
          </div>
        </div>
      })
    }
    {
      junoNots.length === 0 &&
      <p className='card card-header text-center'>{loadingJunoNots ? 'Loading...' : 'No JunoNots Found'}</p>
    }
  </div>
</div>

<br /> <br />
<div className="container" style={{}}>

  <div className="row justify-content-center">
    <div className="col-lg-12">
      <div className="text-center">
        <h6 className="text-gradiant fw-bold"></h6>
        <br />
        <h1 className="fw-bold">FreedomNots</h1>

        <h6 className='text-white'>
          Freedom NOTs support Ukraine's independence and sovereignty. Freedom NOTs are symbols of global compassion, love, and respect for the Ukrainian people.
        </h6>

      </div>
    </div>
  </div>
</div>

<div className="container mt-5">
  <div className="row justify-content-center">
    {
      freedomNots.map((e, i) => {

        let data = JSON.parse(e.data)

        // let rarity = this.getSeriesBadge(e.Pose)
        
        let score = parseInt(e['Total Point']);

        // let getPercent = ((score - 2610) * 100) / (8135 - 2610);

        // let attributes = []

        let image = e.media_uri;

        return <div className='col-md-3' key={i.toString()}>
          <div className='flex-row justify-content-between card p-2 mt-3'>
          {/* <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div> */}
            <div className='' style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent : 'center',
              alignItems : 'center',
              flex : 1,
            }}>
                <img src={image} className="mt-2" height={200} />
                <h3 className='text-center nft-name'>{e.name}</h3>
              {/* {rarity} */}
              {/* <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                animate={false}
                percent={getPercent/100}
                colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                style={{
                  width : 200
                }}
              /> */}
              {/* <span className='info text-center'> Total rarity score %</span> */}
          
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
            </div>

            {/* <div className='flex-fill'>
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
              <h3 className='text-center nft-name'>{e.name}</h3>
              <div style={{
                paddingLeft : 10
              }}>
                {
                  attributes
                }
              </div>
            </div> */}
          </div>
        </div>
      })
    }
    {
      freedomNots.length === 0 &&
      <p className='card card-header text-center'>{loadingFreedomNots ? 'Loading...' : 'No FreedomNots Found'}</p>
    }
  </div>
</div>


<div className="container" style={{}}>

  <div className="row justify-content-center">
    <div className="col-lg-12">
      <div className="text-center">
        <h6 className="text-gradiant fw-bold"></h6>
        <br />
        <h1 className="fw-bold">HeroNots (3DNots)</h1>

        <h6 className='text-white'>
          3dNOTs are heroic defenders that help other IBC NOTs in protecting the Cosmos. They are high utility NFTs created by NOTs. 3dNOTs can be staked on any NOTs supported validating node for a commission discount.
        </h6>
      </div>
    </div>
  </div>
</div>

<div className="container mt-5">
  <div className="row justify-content-center">
    {
      heroNots.map((e, i) => {

        let data = JSON.parse(e.data)

        // let rarity = this.getSeriesBadge(e.Pose)
        
        let score = parseInt(e['Total Point']);

        // let getPercent = ((score - 2610) * 100) / (8135 - 2610);

        // let attributes = []

        let image = e.media_uri;

        return <div className='col-md-3' key={i.toString()}>
          <div className='flex-row justify-content-between card p-2 mt-3'>
          {/* <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div> */}
            <div className='' style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent : 'center',
              alignItems : 'center',
              flex : 1,
            }}>
                <img src={image} className="mt-2" height={200} />
                <h3 className='text-center nft-name'>{e.name}</h3>
              {/* {rarity} */}
              {/* <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                animate={false}
                percent={getPercent/100}
                colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                style={{
                  width : 200
                }}
              /> */}
              {/* <span className='info text-center'> Total rarity score %</span> */}
          
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
            </div>

            {/* <div className='flex-fill'>
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
              <h3 className='text-center nft-name'>{e.name}</h3>
              <div style={{
                paddingLeft : 10
              }}>
                {
                  attributes
                }
              </div>
            </div> */}
          </div>
        </div>
      })
    }
    {
      heroNots.length === 0 &&
      <p className='card card-header text-center'>{loadingHeroNots ? 'Loading...' : 'No HeroNots Found'}</p>
    }
  </div>
</div>

<div className="container" style={{}}>

  <div className="row justify-content-center">
    <div className="col-lg-12">
      <div className="text-center">
        <h6 className="text-gradiant fw-bold"></h6>
        <br />
        <h1 className="fw-bold">JunoPixs</h1>

        <h6 className='text-white'>
          PixelNOTs are retro cool throwbacks to early gaming pixelation blended with NOTs distinct look for each IBC NFT series.
        </h6>

      </div>
    </div>
  </div>
</div>

<div className="container mt-5">
  <div className="row justify-content-center">
    {
      junoPixs.map((e, i) => {

        let data = JSON.parse(e.data)

        // let rarity = this.getSeriesBadge(e.Pose)
        
        let score = parseInt(e['Total Point']);

        // let getPercent = ((score - 2610) * 100) / (8135 - 2610);

        // let attributes = []

        let image = e.media_uri;

        return <div className='col-md-3' key={i.toString()}>
          <div className='flex-row justify-content-between card p-2 mt-3'>
          {/* <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div> */}
            <div className='' style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent : 'center',
              alignItems : 'center',
              flex : 1,
            }}>
                <img src={image} className="mt-2" height={200} />
                <h3 className='text-center nft-name'>{e.name}</h3>
              {/* {rarity} */}
              {/* <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                animate={false}
                percent={getPercent/100}
                colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                style={{
                  width : 200
                }}
              /> */}
              {/* <span className='info text-center'> Total rarity score %</span> */}
          
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
            </div>

            {/* <div className='flex-fill'>
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
              <h3 className='text-center nft-name'>{e.name}</h3>
              <div style={{
                paddingLeft : 10
              }}>
                {
                  attributes
                }
              </div>
            </div> */}
          </div>
        </div>
      })
    }
    {
      junoPixs.length === 0 &&
      <p className='card card-header text-center'>{loadingJunoPixs ? 'Loading...' : 'No JunoPixs Found'}</p>
    }
  </div>
</div>

<div className="container" style={{}}>

  <div className="row justify-content-center">
    <div className="col-lg-12">
      <div className="text-center">
        <h6 className="text-gradiant fw-bold"></h6>
        <br />
        <h1 className="fw-bold">StarPixs</h1>

        <h6 className='text-white'>
          PixelNOTs are retro cool throwbacks to early gaming pixelation blended with NOTs distinct look for each IBC NFT series.
        </h6>

      </div>
    </div>
  </div>
</div>

<div className="container mt-5">
  <div className="row justify-content-center">
    {
      starPixs.map((e, i) => {

        let data = JSON.parse(e.data)

        // let rarity = this.getSeriesBadge(e.Pose)
        
        let score = parseInt(e['Total Point']);

        // let getPercent = ((score - 2610) * 100) / (8135 - 2610);

        // let attributes = []

        let image = e.media_uri;

        return <div className='col-md-3' key={i.toString()}>
          <div className='flex-row justify-content-between card p-2 mt-3'>
          {/* <div class="ribbon ribbon-top-left"><span className=''>#{e.Rank}</span></div> */}
            <div className='' style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent : 'center',
              alignItems : 'center',
              flex : 1,
            }}>
                <img src={image} className="mt-2" height={200} />
                <h3 className='text-center nft-name'>{e.name}</h3>
              {/* {rarity} */}
              {/* <GaugeChart id="gauge-chart2"
                nrOfLevels={20}
                animate={false}
                percent={getPercent/100}
                colors={['#EA4228', '#F5CD19','#5BE12C' ]}
                style={{
                  width : 200
                }}
              /> */}
              {/* <span className='info text-center'> Total rarity score %</span> */}
          
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
            </div>

            {/* <div className='flex-fill'>
              {e.chain === 'omni' ?
               <img src='https://app.omniflix.studio/static/media/Nucleus.56780433.svg' className='chain-img'/> :
               <img src='https://app.stargaze.zone/_next/image?url=%2Flogo.png&w=128&q=75' className='chain-img'/>
              }
              <h3 className='text-center nft-name'>{e.name}</h3>
              <div style={{
                paddingLeft : 10
              }}>
                {
                  attributes
                }
              </div>
            </div> */}
          </div>
        </div>
      })
    }
    {
      starPixs.length === 0 &&
      <p className='card card-header text-center'>{loadingStarPixs ? 'Loading...' : 'No StarPixs Found'}</p>
    }
  </div>
</div>


<div style={{
  height: 100
}}></div>

<Footer />
</>

);
}

}